import { postDataAgnostic } from './dataApi';

/**
 * Track when a candidate views their schedule
 * @param {string} clientID - The candidate's UUID
 * @param {object} dContext - Department context (not used but kept for backwards compatibility)
 * @param {boolean} isPreview - Whether this is a preview mode (admin viewing on behalf of candidate)
 */
export const trackScheduleView = (clientID, dContext, isPreview = false) => {
  if (!isPreview && clientID && clientID.toUpperCase() !== 'DEMO') {
                                                                     // Only track if not in preview mode and not demo
                                                                     const requestData = {
                                                                       ScheduleUUID: clientID,
                                                                     };

                                                                     postDataAgnostic(
                                                                       'candidate/schedule/view',
                                                                       null,
                                                                       requestData,
                                                                     )
                                                                       .then((response) => {
                                                                         // Schedule view tracked successfully
                                                                       })
                                                                       .catch((err) => {
                                                                         console.error(
                                                                           'Error tracking schedule view:',
                                                                           err,
                                                                         );
                                                                       });
                                                                   }
};

/**
 * Track when a candidate views their invitation
 * @param {string} clientID - The candidate's UUID
 * @param {object} dContext - Department context (not used but kept for backwards compatibility)
 * @param {boolean} isPreview - Whether this is a preview mode (admin viewing on behalf of candidate)
 */
export const trackInvitationView = (clientID, dContext, isPreview = false) => {
  if (!isPreview && clientID && clientID.toUpperCase() !== 'DEMO') {
                                                                     // Only track if not in preview mode and not demo
                                                                     const requestData = {
                                                                       CandidateUUID: clientID,
                                                                     };

                                                                     postDataAgnostic(
                                                                       'candidate/invitation/view',
                                                                       null,
                                                                       requestData,
                                                                     )
                                                                       .then((response) => {
                                                                         // Invitation view tracked successfully
                                                                       })
                                                                       .catch((err) => {
                                                                         console.error(
                                                                           'Error tracking invitation view:',
                                                                           err,
                                                                         );
                                                                       });
                                                                   }
};
